<div class="container">
  <div class="ga-nav" role="toolbar">
    <ng-content select="[slot='nav']"></ng-content>
  </div>
  <div class="ga-app" role="main">
    <ng-content select="[slot='app']"></ng-content>
  </div>
</div>
